// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional


const firebaseConfig = {
  apiKey: "AIzaSyAlUpWd4USGjH7LIB5tReQ0l22DbW8y9k4",
  authDomain: "lea-training.firebaseapp.com",
  projectId: "lea-training",
  storageBucket: "lea-training.firebasestorage.app",
  messagingSenderId: "538296731900",
  appId: "1:538296731900:web:e10c69618b8a07e2eb6f79",
  measurementId: "G-WSLSMZH1G8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export const auth = getAuth(app);
export const firebaseMessaging = messaging;
export default app;